<template functional>
  <div
    v-if="props.duration && (props.watched !== null && props.watched !== undefined)"
    class="attachment-progress-component"
  >
    <div
      class="progress-bar"
      :style="{ width: `${Math.round((props.watched/Number(props.duration)) * 100)}%` }"
    />
  </div>
</template>

<script>
export default {
  props: {
    duration: {
      type: String,
    },
    watched: {
      type: Number,
    },
  },
};
</script>

<style lang="scss" scoped>
.attachment-progress-component {
  background-color: rgba(0,0,0,0.5);
  width: 100%;
  position: absolute;
  z-index: 10;
  bottom: 0;
  left: 0;
  height: rem-calc(4);

  .progress-bar {
    background-color: #00d8f8;
    height: 100%;
  }
}
</style>
